import { addDays, addMonths, addYears, setHours, startOfWeek } from 'date-fns';

/**
 * getTargetDayDateByArrowKeyType - A function that returns the target date based on the key pressed.
 *
 * It accepts an `ArrowKeyType` and a `Date` object and returns the target date.
 * The target date is calculated based on the key pressed based on: https://www.w3.org/WAI/ARIA/apg/patterns/dialog-modal/examples/datepicker-dialog/#kbd_label
 */
export var getTargetDayDateByArrowKeyType = (key, dayDate, weekDays) => {
  switch (key) {
    case 'ArrowUp':
      return addDays(dayDate, -7);

    case 'ArrowDown':
      return addDays(dayDate, 7);

    case 'ArrowLeft':
      return addDays(dayDate, -1);

    case 'ArrowRight':
      return addDays(dayDate, 1);

    case 'Home':
      {
        var _weekDays$;

        // get the date of the first day of the week
        var weekStartsOn = (_weekDays$ = weekDays === null || weekDays === void 0 ? void 0 : weekDays[0]) !== null && _weekDays$ !== void 0 ? _weekDays$ : 0; // set the time to 12:00 PM

        return setHours(startOfWeek(dayDate, {
          weekStartsOn
        }), 12);
      }

    case 'End':
      {
        var _weekDays;

        var weekEndsOn = (_weekDays = weekDays === null || weekDays === void 0 ? void 0 : weekDays[weekDays.length - 1]) !== null && _weekDays !== void 0 ? _weekDays : 6;
        var daysToAdd = weekEndsOn - dayDate.getDay(); // get the date of the last day of the week

        return addDays(dayDate, daysToAdd);
      }

    case 'PageUp':
      // get the same date in the following month
      return addMonths(dayDate, 1);

    case 'PageDown':
      // get the same date in the previous month
      return addMonths(dayDate, -1);

    case 'PageUp + Shift':
      // get the same date in the following year
      return addYears(dayDate, 1);

    case 'PageDown + Shift':
      // get the same date in the previous year
      return addYears(dayDate, -1);

    default:
      return;
  }
};
//# sourceMappingURL=getTargetDayDateByArrowKeyType.js.map